import { Image, Text, View } from '@react-pdf/renderer'

import { PDF_FALLBACK_LOGO_SRC } from '../pdfTheme'
import { styles } from '../styles'

export const Header = ({ settings }) => (
  <View fixed style={styles.header}>
    <View style={styles.logoContainer}>
      {settings?.logo ? (
        <Image src={settings.logo} style={styles.logoImage} alt="Logo" />
      ) : (
        <Image
          src={PDF_FALLBACK_LOGO_SRC}
          style={styles.logoImage}
          alt="Logo skop"
        />
      )}
    </View>
    <View style={styles.headerTitle}>
      <Text
        style={[styles.titleText, settings?.color && { color: settings.color }]}
      >
        {settings?.tagline}
      </Text>
    </View>
  </View>
)
